import types from './types';

export const setEditorValue = (value) => ({
  payload: value,
  type: types.SET_EDITOR_VALUE,
});

export const setLayoutType = (value) => ({ // Graph Layout
  payload: value,
  type: types.SET_LAYOUT_TYPE,
});

// bool
export const setIsUseForceLayout= (value) => ({
  payload: value,
  type: types.SET_IS_USE_FORCE_LAYOUT,
})


export default {
  setEditorValue,
  setIsUseForceLayout
}
